import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@badi/badi-components";
import { translate } from "base/shared/Localization";
import Metric from "./metric";

const Metrics = ({ lastConnection, responseRatio }) => (
  <Flex gutter={2}>
    <Metric
      dataQa="response-metric"
      label={translate("user.metrics.response.rate")}
    >
      {responseRatio}
    </Metric>
    <Metric
      dataQa="activity-metric"
      label={translate("user.metrics.lastActive")}
    >
      {lastConnection}
    </Metric>
  </Flex>
);

Metrics.propTypes = {
  lastConnection: PropTypes.string.isRequired,
  responseRatio: PropTypes.string.isRequired,
};

export default Metrics;
